import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=d78aec98&scoped=true&"
import script from "./PageHeading.vue?vue&type=script&lang=js&"
export * from "./PageHeading.vue?vue&type=script&lang=js&"
import style0 from "./PageHeading.vue?vue&type=style&index=0&id=d78aec98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d78aec98",
  null
  
)

export default component.exports